
export const root = {
    gap: '0.5rem'
};

export const input = {
    width: '2.5rem',
    sm: {
        width: '2rem'
    },
    lg: {
        width: '3rem'
    }
};

export default {
    root,
    input
};
